import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../../tailwind.config.js'
import toPx from 'to-px';

export {
    scrollBy,
    scrollTo,
    lockBodyScroll,
    unlockBodyScroll,
} from './scroll';

export {
    debounce,
    delay,
    throttle,
} from './rateLimiting';

export {
    shrinkWrap,
    unshrinkWrap,
} from './sizing';

export { fitText } from './text';

const config = resolveConfig(tailwindConfig)

export { default as toPx } from 'to-px';

export { waitUntil } from 'async-wait-until';

export { default as mobile } from 'is-mobile';

export const breakpoints = (() => (
    Object.keys(config.theme.screens).reduce(
        (breakpoints, breakpoint) => ({
            ...breakpoints,
            [breakpoint]: (
                toPx(
                    config.theme.screens[breakpoint]
                )
            )
        }),
        {}
    )
))();

export const isScreenAtLeast = (size) => (
    $(window).outerWidth() >= breakpoints[size]
);

export const colors = config.theme.colors;

export const gsapTimelinePromise = (timeline) => (
    new Promise((resolve) => {
        timeline.eventCallback(
            'onComplete',
            () => resolve(timeline)
        );
        timeline.play();
    })
);

export const loadSvg = (key) => (
    $(`[data-svg="${key}"]`).html()
);

